import React from "react";
import content from "../data/results/2015content.json";
import resultData from "../data/2015data.json";
import ResultsPage from "./ResultsPage";

const Results2015 = () => <ResultsPage content={content} resultData={resultData} />;

export default Results2015;
